// material-ui
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import menuItems from 'components/layout/MainLayout/MenuItems';
import { MenuCampaignsSelectors } from 'store/menuCampaignsSlice';

import NavGroup from './NavGroup';

const MenuList = () => {
  const pendingCampaigns = useSelector(MenuCampaignsSelectors.allPending);
  const menu = menuItems(pendingCampaigns);

  const navItems = menu.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return navItems;
};

export default MenuList;
